import React, { useContext, useEffect, useState } from 'react'
import { t } from 'i18next';
import OpenningManagementContext from '../../context/OpenningsManagmentContext/OpenningManagementContext';
import ItemSelectableWithSwitch from '../ItemSelectable/ItemSelectableWithSwitch';
import { Spinner } from 'reactstrap';
import '../../containers/Settings/settings.css';
import { CustomModal } from '../CustomModal/CustomModal';
import errorIcon from '../../assets/icons/triangule-exclamation.svg'

export const EnableOpennings = () => {

    const { openningManagementState, getOpennigsManagement, changeConfigToOpenning, cleanOpenningManagementState } = useContext(OpenningManagementContext);
    const { openningsToConfig, isFetching, error } = openningManagementState;

    const [options, setOptions] = useState([]);

    const getOpenningsList = async () => {
        await cleanOpenningManagementState();
        await getOpennigsManagement();
    }

    const handleChange = async (key, value) => {
        const newOpts = options.map((opt) => opt.code === key ? { ...opt, ...{ is_access: value ? 1 : 0 } } : opt);
        setOptions(newOpts);
        await changeConfigToOpenning({ opening_code: key, is_access: value });
    }

    const fiterOpennings = (value) => {
        if (openningsToConfig.length) {
            value = value.toLowerCase();
            const filteredObjects = openningsToConfig.filter((opt) => {
                return opt.description.toLowerCase().includes(value) || opt.code.toLowerCase().includes(value);
            });

            setOptions(filteredObjects);
        }
    }

    const closeErrorModal = async () => {
        await cleanOpenningManagementState();
        getOpenningsList();
    }

    useEffect(() => {
        getOpenningsList();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setOptions(openningsToConfig);
        // eslint-disable-next-line
    }, [openningsToConfig]);

    return (
        <>

            <div className='mt-2 mb-2'>
                <input
                    placeholder={t('SEARCH_OPENNINGS')}
                    type={"text"}
                    name={'searchOpennings'}
                    className="form-control access-input"
                    autoComplete='off'
                    onChange={(e) => fiterOpennings(e.target.value)}
                />
            </div>

            {error.ok ?
                <CustomModal showModal={error.ok} centered={true} setShowModal={closeErrorModal}>
                    <div className='d-flex flex-column align-items-center justify-content-center'>
                        <img src={errorIcon} alt="" />
                        <p className='mt-3 text-center param-section-title'>{error.text}</p>
                        <p type="button" className='custom-modal-btn-ok' onClick={closeErrorModal}>{t('UNDERSTOOD')}</p>
                    </div>
                </CustomModal>
                : null}

            {isFetching ?
                <div className="d-flex mt-4 justify-content-center">
                    <Spinner />
                </div>
                : null}

            <div className='itemsList'>
                {
                    options.length ?
                        options.map((opt, i) => {
                            return (
                                <div key={i} className='mb-2'>
                                    <ItemSelectableWithSwitch checked={Number(opt.is_access) === 1 ? true : false} onChange={() => handleChange(opt.code, !Number(opt.is_access))}>
                                        <div>
                                            <p className='m-0 param-section-title'>{opt.description}</p>
                                            <p className='m-0 param-section-subtitle'>{opt.code}</p>
                                        </div>
                                    </ItemSelectableWithSwitch>
                                </div>
                            )
                        })
                        : null
                }
            </div>



        </>
    )
}
